module.exports = __webpack_public_path__ + "img/djs.793aade5.png";